module.exports = __webpack_public_path__ + "static/media/right@2x.1a4bbd5b.png";